import { _initialState } from './_initialState';
import {
  updateChoice,
  updateConfigurator,
  updateMobile,
  updateDrawer,
  updateConfiguratorMetadata,
  setSelectedProduct,
  clearSelectedProduct,
  getSelectedProduct,
} from './actions';

export const configuratorStore = (set, get) => ({
  ..._initialState,
  updateConfigurator: (data) => updateConfigurator(set, get, data),
  updateChoice: (choiceId, data) => updateChoice(set, get, choiceId, data),
  updateMobile: (selectedOptionName, selectedOptionLabel) => updateMobile(
    set,
    selectedOptionName,
    selectedOptionLabel
  ),
  updateDrawer: (data) => updateDrawer(set, data),
  updateConfiguratorMetadata: (choiceId, choiceMetadata) => updateConfiguratorMetadata(
    set,
    get,
    choiceId,
    choiceMetadata
  ),
  setSelectedProduct: (product) => setSelectedProduct(set, get, product),
  clearSelectedProduct: () => clearSelectedProduct(set),
  getSelectedProduct: () => getSelectedProduct(get),
});
